<template>
  <div class="login-page">
    <div class="login-wrapper">
      <!-- 左侧品牌区 -->
      <div class="login-brand">
        <div class="brand-decoration"></div>
        <div class="brand-content">
          <div class="brand-logo">
            <svg class="w-7 h-7" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z" />
            </svg>
          </div>
          <h1 class="brand-title">AI管理能力<br>提升助手</h1>
          <p class="brand-slogan">让管理问题有解</p>
          <p class="brand-slogan-sub">从"被动应对"到"主动预判"</p>

          <div class="brand-features">
            <div class="feature-item">
              <div class="feature-check">
                <svg class="w-3 h-3" fill="none" stroke="currentColor" stroke-width="3" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <span>AI 深度诊断，精准定位管理痛点</span>
            </div>
            <div class="feature-item">
              <div class="feature-check">
                <svg class="w-3 h-3" fill="none" stroke="currentColor" stroke-width="3" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <span>专家实战案例，即学即用的解决方案</span>
            </div>
            <div class="feature-item">
              <div class="feature-check">
                <svg class="w-3 h-3" fill="none" stroke="currentColor" stroke-width="3" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <span>情景模拟演练，在实战中提升管理能力</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 右侧登录区 -->
      <div class="login-form-area">
        <div class="login-card">
          <div class="login-header">
            <h2 class="login-title">欢迎回来</h2>
            <p class="login-subtitle">请选择您的身份进入系统</p>
          </div>

          <div class="role-buttons">
            <!-- 主管 -->
            <div
              class="role-card"
              :class="{ active: selectedRole === 'user' }"
              @click="selectRole('user')"
            >
              <div class="role-icon manager">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
              </div>
              <div class="role-info">
                <div class="role-name">主管</div>
                <div class="role-desc">使用前台功能，学习管理知识</div>
              </div>
              <svg
                class="w-4 h-4 role-arrow"
                :class="{ active: selectedRole === 'user' }"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                viewBox="0 0 24 24"
              >
                <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
              </svg>
            </div>

            <!-- 普通管理员 -->
            <div
              class="role-card"
              :class="{ active: selectedRole === 'admin' }"
              @click="selectRole('admin')"
            >
              <div class="role-icon normal-admin">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
              </div>
              <div class="role-info">
                <div class="role-name">普通管理员</div>
                <div class="role-desc">后台数据管理与内容配置</div>
              </div>
              <svg
                class="w-4 h-4 role-arrow"
                :class="{ active: selectedRole === 'admin' }"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                viewBox="0 0 24 24"
              >
                <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
              </svg>
            </div>

            <!-- 超级管理员 -->
            <div
              class="role-card"
              :class="{ active: selectedRole === 'super_admin' }"
              @click="selectRole('super_admin')"
            >
              <div class="role-icon super-admin">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                  <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
              </div>
              <div class="role-info">
                <div class="role-name">超级管理员</div>
                <div class="role-desc">系统配置与权限管理</div>
              </div>
              <svg
                class="w-4 h-4 role-arrow"
                :class="{ active: selectedRole === 'super_admin' }"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                viewBox="0 0 24 24"
              >
                <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
              </svg>
            </div>
          </div>

          <button
            class="login-btn"
            :disabled="!selectedRole"
            @click="login"
          >
            <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" d="M13 7l5 5m0 0l-5 5m5-5H6" />
            </svg>
            立即进入系统
          </button>

          <p class="login-hint">
            <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            演示环境，选择角色即可进入，无需密码
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ROLES } from '../data/adminConfig'

export default {
  name: 'LoginPage',

  data() {
    return {
      selectedRole: '',
    }
  },

  methods: {
    selectRole(role) {
      this.selectedRole = role
    },

    login() {
      if (!this.selectedRole) return

      const roleMap = {
        'user': ROLES.USER,
        'admin': ROLES.ADMIN,
        'super_admin': ROLES.SUPER_ADMIN,
      }

      const actualRole = roleMap[this.selectedRole]

      this.$store.commit('SET_IS_LOGGED_IN', true)
      this.$store.commit('SET_USER_ROLE', actualRole)

      if (this.selectedRole === 'user') {
        this.$router.push('/').catch(() => {})
      } else {
        this.$router.push('/admin').catch(() => {})
      }
    },
  },
}
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-bg);
  padding: 24px;
}

.login-wrapper {
  display: flex;
  width: 900px;
  max-width: 95vw;
  min-height: 560px;
  background: var(--color-surface);
  border-radius: 24px;
  box-shadow: var(--shadow-lg);
  overflow: hidden;
}

/* ===== 左侧品牌区 ===== */
.login-brand {
  flex: 1;
  background: linear-gradient(135deg, #2C4A6E 0%, #1B3C59 100%);
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px;
  overflow: hidden;
}

.brand-decoration {
  position: absolute;
  bottom: -60px;
  right: -60px;
  width: 200px;
  height: 200px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.08);
}

.brand-decoration::before {
  content: '';
  position: absolute;
  top: -60px;
  left: -100px;
  width: 140px;
  height: 140px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.05);
}

.brand-content {
  position: relative;
  z-index: 1;
  color: white;
}

.brand-logo {
  width: 56px;
  height: 56px;
  background: linear-gradient(135deg, #F2C94C, #D4A72E);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1B3C59;
  margin-bottom: 24px;
}

.brand-title {
  font-size: 32px;
  font-weight: 700;
  line-height: 1.2;
  margin: 0 0 16px 0;
}

.brand-slogan {
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 6px 0;
  opacity: 0.95;
}

.brand-slogan-sub {
  font-size: 14px;
  margin: 0 0 32px 0;
  opacity: 0.7;
}

.brand-features {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  opacity: 0.85;
}

.feature-check {
  width: 20px;
  height: 20px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

/* ===== 右侧登录区 ===== */
.login-form-area {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px;
}

.login-card {
  width: 100%;
  max-width: 360px;
}

.login-header {
  text-align: center;
  margin-bottom: 32px;
}

.login-title {
  font-size: 24px;
  font-weight: 700;
  color: var(--color-text);
  margin: 0 0 8px 0;
}

.login-subtitle {
  font-size: 14px;
  color: var(--color-text-secondary);
  margin: 0;
}

/* 角色选择 */
.role-buttons {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 24px;
}

.role-card {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 20px;
  border: 2px solid var(--color-border);
  border-radius: 14px;
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);
  background: var(--color-surface);
}

.role-card:hover {
  border-color: rgba(242, 201, 76, 0.5);
  box-shadow: var(--shadow-md);
  transform: translateY(-2px);
}

.role-card.active {
  border-color: var(--color-primary);
  background: rgba(242, 201, 76, 0.06);
  box-shadow: 0 0 12px rgba(242, 201, 76, 0.15);
}

.role-icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.role-icon.manager {
  background: linear-gradient(135deg, #BFDBFE, #93C5FD);
  color: #1E40AF;
}

.role-icon.normal-admin {
  background: linear-gradient(135deg, #D1FAE5, #A7F3D0);
  color: #065F46;
}

.role-icon.super-admin {
  background: linear-gradient(135deg, #F5D76E, #F2C94C);
  color: #1B3C59;
}

.role-info {
  flex: 1;
}

.role-name {
  font-size: 15px;
  font-weight: 600;
  color: var(--color-text);
}

.role-desc {
  font-size: 12px;
  color: var(--color-text-muted);
  margin-top: 2px;
}

.role-arrow {
  color: var(--color-text-muted);
  transition: all 0.2s ease;
}

.role-card:hover .role-arrow,
.role-arrow.active {
  color: var(--color-primary-dark);
  transform: translateX(4px);
}

/* 登录按钮 */
.login-btn {
  width: 100%;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  color: #1B3C59;
  background: linear-gradient(135deg, #F5D76E, #F2C94C);
  border: none;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.25s ease;
}

.login-btn:hover:not(:disabled) {
  box-shadow: 0 4px 16px rgba(242, 201, 76, 0.4);
  transform: translateY(-1px);
}

.login-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background: var(--color-border);
  color: var(--color-text-muted);
}

/* 提示 */
.login-hint {
  text-align: center;
  margin-top: 16px;
  font-size: 12px;
  color: var(--color-text-muted);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

@media (max-width: 768px) {
  .login-wrapper {
    flex-direction: column;
    min-height: auto;
  }
  .login-brand {
    padding: 32px;
    min-height: 240px;
  }
  .brand-title {
    font-size: 24px;
  }
  .login-form-area {
    padding: 32px;
  }
}
</style>
